import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';
import { useLanguage } from '../../hooks/useLanguage';

const TermsOfUse: React.FC = () => {
    const { t, isRTL } = useLanguage();

    return (
        <LegalPageTemplate
            title={t('termsOfUse.title')}
            lastUpdated={t('termsOfUse.lastUpdated')}
        >
            <div dir={isRTL ? 'rtl' : 'ltr'}>
                <p className={`text-gray-600 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.intro.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.intro.paragraph2')}
                </p>

                {/* Section 1 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section1.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section1.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section1.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section1.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section1.subsection2.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section1.subsection3.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section1.subsection3.paragraph1')}
                </p>

                {/* Section 2 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section2.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section2.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section2.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section2.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section2.subsection2.paragraph1')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('termsOfUse.section2.subsection2.items.comply')}</li>
                    <li>{t('termsOfUse.section2.subsection2.items.noDisrupt')}</li>
                    <li>{t('termsOfUse.section2.subsection2.items.noFraud')}</li>
                    <li>{t('termsOfUse.section2.subsection2.items.respectRights')}</li>
                    <li>{t('termsOfUse.section2.subsection2.items.responsible')}</li>
                </ul>

                {/* Section 3 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section3.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section3.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section3.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section3.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section3.subsection2.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section3.subsection3.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section3.subsection3.paragraph1')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('termsOfUse.section3.subsection3.items.noCopy')}</li>
                    <li>{t('termsOfUse.section3.subsection3.items.noReverse')}</li>
                    <li>{t('termsOfUse.section3.subsection3.items.noRemove')}</li>
                </ul>

                {/* Section 4 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section4.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section4.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section4.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section4.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section4.subsection2.paragraph1')}
                </p>

                {/* Section 5 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section5.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section5.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section5.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section5.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section5.subsection2.paragraph1')}
                </p>

                {/* Section 6 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section6.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section6.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section6.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section6.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfUse.section6.subsection2.paragraph1')}
                </p>
            </div>
        </LegalPageTemplate>
    );
};

export default TermsOfUse;